import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Skull, Loader2, CheckCircle2 } from "lucide-react";

export default function AdminReset() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Heslo musí mít alespoň 6 znaků."); return; }
    if (pw !== pw2) { toast.error("Hesla se neshodují."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset", { token, new_password: pw });
      setDone(true);
      toast.success("Heslo změněno.");
      setTimeout(() => nav("/admin"), 2500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Obnova selhala.");
    } finally { setLoading(false); }
  };

  return (
    <div className="grain min-h-screen bg-[#050505] flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 bg-black/70 scanlines" />
      <div className="relative z-30 w-full max-w-sm border border-white/10 bg-[#0a0a0a]/90 p-8 border-t-2 border-t-red-700" data-testid="admin-reset">
        <div className="flex items-center gap-2 justify-center mb-6">
          <Skull className="w-6 h-6 text-red-600" />
          <h1 className="font-head text-xl uppercase tracking-widest text-neutral-100">Nové heslo</h1>
        </div>
        {done ? (
          <div className="text-center py-6" data-testid="reset-done">
            <CheckCircle2 className="w-12 h-12 text-nv mx-auto mb-3" />
            <p className="text-neutral-300">Heslo bylo změněno. Přesměrování na přihlášení…</p>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="mb-4">
              <Label className="text-xs text-neutral-400">Nové heslo</Label>
              <Input data-testid="reset-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)}
                className="rounded-none bg-[#111] border-white/10 focus-visible:ring-red-700 mt-1" />
            </div>
            <div className="mb-6">
              <Label className="text-xs text-neutral-400">Heslo znovu</Label>
              <Input data-testid="reset-pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)}
                className="rounded-none bg-[#111] border-white/10 focus-visible:ring-red-700 mt-1" />
            </div>
            <Button data-testid="reset-submit" disabled={loading} type="submit"
              className="vhs-btn w-full rounded-none bg-red-700 hover:bg-red-600 text-white font-head tracking-widest py-6">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "ZMĚNIT HESLO"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
